import { render, staticRenderFns } from "./JoinPayment.vue?vue&type=template&id=7436be13"
import script from "./JoinPayment.vue?vue&type=script&lang=js"
export * from "./JoinPayment.vue?vue&type=script&lang=js"
import style0 from "./JoinPayment.vue?vue&type=style&index=0&id=7436be13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports